import { GQLResponsePerimeterXChallengeError } from '@change-corgi/core/gql';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	StarterDashboardV2PetitionRecentSignersConnectionDataQuery,
	StarterDashboardV2PetitionRecentSignersConnectionDataQueryVariables,
} from '../petitionRecentSigners.graphql';
import { StarterDashboardV2PetitionRecentSignersConnectionData } from '../petitionRecentSigners.graphql';

type SuccessResponse = NonNullable<
	StarterDashboardV2PetitionRecentSignersConnectionDataQuery['petition']
>['recentSignersConnection'] & {
	__typename: 'PetitionRecentSignersConnectionSuccess';
};

export async function getPetitionRecentSigners(
	{ gql: { fetch }, errorReporter }: UtilityContext,
	{ slug }: { slug: string },
): Promise<SuccessResponse | null> {
	try {
		const { data } = await fetch<
			StarterDashboardV2PetitionRecentSignersConnectionDataQuery,
			StarterDashboardV2PetitionRecentSignersConnectionDataQueryVariables
		>({
			batched: false, // to ensure this rate limited mutation is not batched
			path: '/petitionRecentSigners',
			query: StarterDashboardV2PetitionRecentSignersConnectionData,
			rejectOnError: true,
			variables: { slug },
		});

		if (data.petition?.recentSignersConnection.__typename === 'PetitionRecentSignersConnectionSuccess') {
			return data.petition.recentSignersConnection;
		}
	} catch (error) {
		if (error instanceof GQLResponsePerimeterXChallengeError) {
			void errorReporter.report({
				error,
				params: {
					petitionSlug: slug,
					action: 'getPetitionRecentSigners',
					message: 'PerimeterX error while fetching petition recent signers on starter dashboard',
				},
			});
		}
	}

	return null;
}
